import { GetterTree } from 'vuex'
import { AuthState, IAuthState } from './state';

export const authGetters: GetterTree<AuthState, IAuthState> = {
  isAuthenticated: (state: AuthState) => state.isAuthenticated,
  userInfo: (state: AuthState) => state.user,
  appConfigSettings: (state: AuthState) => state.appConfigSettings,
  appConfigLoaded: (state: AuthState) => state.appConfigLoaded,
};
